import { Controller, useFormContext } from "react-hook-form";

import { loadLocale } from "@smart/itops-locale-dom";
import { RadioButtons } from "@smart/itops-sb-design-system-dom";

export const HeaderTextColor = ({ disabled }: { disabled?: boolean }) => {
  const { control } = useFormContext();
  const locale = loadLocale();
  const colorTerm = locale.terms.colour;

  return (
    <div className="flex flex-col gap-[1.2rem]">
      <div className="flex flex-col gap-xSmall">
        <div className="text-paragraph font-semibold">
          Header Text {colorTerm.header}
        </div>
        <span className="text-caption text-neutral-600">
          Ensure your text stands out if you have changed the background{" "}
          {colorTerm.name}.
        </span>
      </div>
      <Controller
        control={control}
        name="headerTextColor"
        render={({ field }) => (
          <RadioButtons
            options={[
              { label: "Default", value: "default" },
              { label: `Brand ${colorTerm.header}`, value: "brandColor" },
              { label: "White", value: "white" },
            ]}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            disabled={disabled}
            className="text-ui"
          />
        )}
      />
    </div>
  );
};
